var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import find from 'lodash/find';
import ConfigShippingView from './ConfigShippingView';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

var ConfigShippingContainer =
/** @class */
function (_super) {
  __extends(ConfigShippingContainer, _super);

  function ConfigShippingContainer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      selectedDeliveryLocation: undefined,
      selectedFulfillmentLocation: undefined,
      shippingTime: 0,
      postalCode: '',
      city: undefined,
      isSaveShippingEnabled: false
    };

    _this.componentDidMount = function () {
      var _a = _this.props,
          shippingConfig = _a.shippingConfig,
          deliveryLocations = _a.deliveryLocations,
          isSaveShippingEnabled = _a.isSaveShippingEnabled,
          fulfillmentLocations = _a.fulfillmentLocations;
      if (!shippingConfig) return;
      var selectedDeliverylocation = find(deliveryLocations, function (option) {
        return option.value === shippingConfig.destinationCountryCode;
      });

      _this.setState({
        selectedDeliveryLocation: selectedDeliverylocation,
        shippingTime: shippingConfig.shippingTime,
        city: shippingConfig.city,
        selectedFulfillmentLocation: shippingConfig.fulfillmentLocation || (fulfillmentLocations && fulfillmentLocations.length === 1 ? fulfillmentLocations[0] : undefined),
        postalCode: shippingConfig.destinationPostalCode,
        isSaveShippingEnabled: isSaveShippingEnabled
      });
    };

    _this.saveFulfillmentLocation = function () {
      var shippingConfig = _this.props.shippingConfig;
      var selectedFulfillmentLocation = _this.state.selectedFulfillmentLocation;
      var shippingConfiguration = cloneDeep(shippingConfig);

      if (!shippingConfiguration) {
        shippingConfiguration = {};
      }

      shippingConfiguration.fulfillmentLocation = selectedFulfillmentLocation;

      _this.props.saveShippingConfig(shippingConfiguration);
    };

    _this.onDeliveryLocationChange = function (selectedSingle) {
      _this.setState({
        selectedDeliveryLocation: selectedSingle
      });
    };

    _this.onFulfillmentLocationChange = function (selectedSingle) {
      _this.setState({
        selectedFulfillmentLocation: selectedSingle
      });
    };

    _this.onPostalCodeInputChange = function (event) {
      _this.setState({
        postalCode: event.target.value
      });
    };

    _this.onCityInputChange = function (event) {
      _this.setState({
        city: event.target.value
      });
    };

    _this.onShippingTimeInputChange = function (e) {
      _this.setState({
        shippingTime: parseInt(e.target.value, 10)
      });
    };

    _this.onChangeSaveShippingConfig = function () {
      // eslint-disable-next-line react/no-access-state-in-setstate
      _this.setState({
        isSaveShippingEnabled: !_this.state.isSaveShippingEnabled
      });
    };

    _this.onSubmit = function () {
      var _a = _this.state,
          selectedDeliveryLocation = _a.selectedDeliveryLocation,
          shippingTime = _a.shippingTime,
          postalCode = _a.postalCode,
          isSaveShippingEnabled = _a.isSaveShippingEnabled,
          city = _a.city,
          selectedFulfillmentLocation = _a.selectedFulfillmentLocation;

      if (_this.props.onShippingSubmit) {
        _this.props.onShippingSubmit(selectedDeliveryLocation ? selectedDeliveryLocation.value : null, postalCode, !shippingTime || shippingTime === 0 ? null : shippingTime, city, selectedFulfillmentLocation, isSaveShippingEnabled);
      }
    };

    _this.onResetAll = function () {
      _this.setState({
        selectedDeliveryLocation: null,
        shippingTime: 0,
        postalCode: '',
        city: '',
        isSaveShippingEnabled: false,
        selectedFulfillmentLocation: null
      }, function () {
        return _this.onSubmit();
      });
    };

    return _this;
  }

  ConfigShippingContainer.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
    var _this = this;

    if (!isEqual(this.props.shippingConfig, prevProps.shippingConfig)) {
      var _a = this.props,
          shippingConfig_1 = _a.shippingConfig,
          deliveryLocations = _a.deliveryLocations,
          isSaveShippingEnabled = _a.isSaveShippingEnabled;
      if (!shippingConfig_1) return;
      var selectedDeliverylocation = find(deliveryLocations, function (option) {
        return option.value === shippingConfig_1.destinationCountryCode;
      });
      this.setState({
        selectedDeliveryLocation: selectedDeliverylocation,
        shippingTime: shippingConfig_1.shippingTime,
        city: shippingConfig_1.city,
        selectedFulfillmentLocation: shippingConfig_1.fulfillmentLocation || undefined,
        postalCode: shippingConfig_1.destinationPostalCode,
        isSaveShippingEnabled: isSaveShippingEnabled
      });
    }

    if (prevProps.isSaveShippingEnabled !== this.props.isSaveShippingEnabled) {
      this.setState({
        isSaveShippingEnabled: this.props.isSaveShippingEnabled
      });
    }

    if (!isEqual(this.props.fulfillmentLocations, prevProps.fulfillmentLocations)) {
      this.setState({
        selectedFulfillmentLocation: undefined
      }, function () {
        return _this.saveFulfillmentLocation();
      });
    }
  };

  ConfigShippingContainer.prototype.render = function () {
    var _a = this.state,
        selectedDeliveryLocation = _a.selectedDeliveryLocation,
        shippingTime = _a.shippingTime,
        postalCode = _a.postalCode,
        isSaveShippingEnabled = _a.isSaveShippingEnabled,
        city = _a.city,
        selectedFulfillmentLocation = _a.selectedFulfillmentLocation;
    var _b = this.props,
        deliveryLocations = _b.deliveryLocations,
        closeModal = _b.closeModal,
        open = _b.open,
        productionTime = _b.productionTime,
        fulfillmentLocations = _b.fulfillmentLocations;
    return React.createElement(ConfigShippingView, {
      deliveryLocations: deliveryLocations,
      fulfillmentLocations: fulfillmentLocations,
      selectedFulfillmentLocation: selectedFulfillmentLocation,
      onFulfillmentLocationChange: this.onFulfillmentLocationChange,
      onDeliveryLocationChange: this.onDeliveryLocationChange,
      onChangeSaveShippingConfig: this.onChangeSaveShippingConfig,
      isSaveShippingEnabled: isSaveShippingEnabled,
      selectedDeliveryLocation: selectedDeliveryLocation,
      shippingTime: shippingTime,
      onShippingTimeInputChange: this.onShippingTimeInputChange,
      postalCode: postalCode,
      onPostalCodeInputChange: this.onPostalCodeInputChange,
      city: city,
      onCityInputChange: this.onCityInputChange,
      onSubmit: this.onSubmit,
      onResetAll: this.onResetAll,
      closeModal: closeModal,
      open: open,
      productionTime: productionTime
    });
  };

  return ConfigShippingContainer;
}(Component);

export default ConfigShippingContainer;